module.exports = __webpack_public_path__ + "static/breitling-e60699ac0f129622cffc4ba4a99b1c0b.png";